import React from 'react';
import { createTooltipIcon } from '../utils/createTooltipIcon';

export const Garlic = createTooltipIcon(
  () => (
    <path
      d="M502.4,310.4c-24-73.6-73.6-108.8-118.4-139.2c-48-33.6-88-62.4-96-131.2c0-6.4-1.6-12.8-1.6-19.2
			c1.6-1.6,1.6-3.2,1.6-4.8c0-9.6-6.4-16-16-16h-32c-9.6,0-16,6.4-16,16c0,1.6,0,1.6,0,3.2c0,6.4,0,12.8,0,19.2
			c-6.4,70.4-48,99.2-96,132.8C83.2,201.6,33.6,236.8,9.6,310.4S16,441.6,52.8,472c22.4,17.6,49.6,27.2,76.8,27.2
			c17.6,0,35.2-4.8,52.8-12.8c22.4,16,46.4,25.6,73.6,25.6c27.2,0,51.2-9.6,73.6-25.6c16,8,33.6,12.8,52.8,12.8
			c27.2,0,54.4-9.6,76.8-27.2C496,443.2,526.4,385.6,502.4,310.4z M73.6,446.4C44.8,424,20.8,379.2,40,320
			c20.8-62.4,62.4-92.8,105.6-123.2c11.2-8,22.4-16,33.6-25.6c-6.4,11.2-12.8,24-19.2,35.2c-19.2,35.2-36.8,65.6-40,96
			c-9.6,64,3.2,120,36.8,160C129.6,472,97.6,465.6,73.6,446.4z M326.4,443.2c-1.6,3.2-4.8,4.8-6.4,8c-3.2,1.6-4.8,3.2-6.4,6.4
			C296,472,276.8,480,256,480s-40-8-57.6-20.8c-1.6-3.2-4.8-4.8-6.4-6.4c-3.2-1.6-4.8-4.8-6.4-8c-28.8-32-40-83.2-32-137.6
			c3.2-24,19.2-52.8,36.8-84.8c25.6-46.4,56-102.4,64-169.6v-1.6c0-3.2,1.6-8,1.6-12.8c0,1.6,0,4.8,0,6.4c0,3.2,0,6.4,1.6,9.6
			c9.6,65.6,38.4,121.6,64,166.4c17.6,33.6,33.6,60.8,36.8,84.8C366.4,361.6,355.2,411.2,326.4,443.2z M438.4,446.4
			c-25.6,19.2-56,25.6-84.8,16c32-40,44.8-96,36.8-160c-4.8-28.8-20.8-60.8-40-96c-6.4-11.2-12.8-22.4-17.6-33.6
			c11.2,8,22.4,16,33.6,24C411.2,227.2,452.8,256,472,320C491.2,379.2,467.2,424,438.4,446.4z"
    />
  ),
  '0 0 512 512'
);
